import { Suspense } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
/**
 * * code splitting
 *  This approach reduces the initial load time by loading the component only when it's needed.
 */
import { lazyImport } from '@/utils/lazy/lazy-import-utils';

import { MainLayout } from '@/components/Layout';
import { Spinner } from '@/components/Elements';

/**
 * todo: should use lazyImport for code splitting
 */
import { ProfilePage } from '@/pages/profile';
import { RequireAuth } from '@/components/Auth/RequireAuth';

const { DashboardRoutes } = lazyImport(
  () => import('@/pages/dashboard'),
  'DashboardRoutes',
);

const { InfynityRoutes } = lazyImport(
  () => import('@/pages/infynity'),
  'InfynityRoutes',
);

import { DocumentExplorerRoutes } from '@/pages/document-explorer/routes';

// const { PurchaseRoutes } = lazyImport(
//   () => import('@/pages/purchase'),
//   'PurchaseRoutes',
// );

// const { RefinanceRoutes } = lazyImport(
//   () => import('@/pages/refinance'),
//   'RefinanceRoutes',
// );
const { LeadRoutes } = lazyImport(() => import('@/pages/lead'), 'LeadRoutes');

const { ContactRoutes } = lazyImport(
  () => import('@/pages/contacts'),
  'ContactRoutes',
);

const { MortgageWorkflowRoutes } = lazyImport(
  () => import('@/pages/mortgage-workflow'),
  'MortgageWorkflowRoutes',
);

const { ClientDetailsRoutes } = lazyImport(
  () => import('@/pages/client-details'),
  'ClientDetailsRoutes',
);

const { ApplicationRoutes } = lazyImport(
  () => import('@/pages/application'),
  'ApplicationRoutes',
);

const { SettingsRoutes } = lazyImport(
  () => import('@/pages/settings'),
  'SettingsRoutes',
);

const { TaxRoutes } = lazyImport(() => import('@/pages/tax'), 'TaxRoutes');
const { ToolsRoutes } = lazyImport(
  () => import('@/pages/tools'),
  'ToolsRoutes',
);

const { DataAnalyticsRoutes } = lazyImport(
  () => import('@/pages/data-analytics'),
  'DataAnalyticsRoutes',
);

const { AccessControlRoutes } = lazyImport(
  () => import('@/pages/access-control'),
  'AccessControlRoutes',
);

const { PropertyRoutes } = lazyImport(
  () => import('@/pages/property-details'),
  'PropertyRoutes',
);

const { DocumentsInviteRoutes } = lazyImport(
  () => import('@/pages/documents-invite'),
  'DocumentsInviteRoutes',
);

const { MarketingRoutes } = lazyImport(
  () => import('@/pages/marketing'),
  'MarketingRoutes',
);
const { AgentsRoutes } = lazyImport(
  () => import('@/pages/agents'),
  'AgentsRoutes',
);
const App = () => {
  return (
    <MainLayout>
      <Suspense fallback={<Spinner />}>
        <Outlet />
      </Suspense>
    </MainLayout>
  );
};

export const protectedRoutes = [
  {
    path: '',
    element: <RequireAuth />,
    children: [
      {
        path: '',
        element: <App />,
        children: [
          { path: 'dashboard/*', element: <DashboardRoutes /> },

          { path: 'profile', element: <ProfilePage /> },
          { path: 'lead/*', element: <LeadRoutes /> },
          { path: 'dashboard/*', element: <DashboardRoutes /> },
          { path: 'data-analytics/*', element: <DataAnalyticsRoutes /> },
          // { path: 'purchase/*', element: <PurchaseRoutes /> },
          // { path: 'refinance/*', element: <RefinanceRoutes /> },
          { path: 'infynity/*', element: <InfynityRoutes /> },
          { path: 'contacts/*', element: <ContactRoutes /> },
          { path: 'property/*', element: <PropertyRoutes /> },
          { path: 'client/overview/*', element: <MortgageWorkflowRoutes /> },
          { path: 'client/details/*', element: <ClientDetailsRoutes /> },
          { path: 'settings/*', element: <SettingsRoutes /> },
          { path: 'application/*', element: <ApplicationRoutes /> },
          { path: 'tax/*', element: <TaxRoutes /> },
          { path: 'tools/*', element: <ToolsRoutes /> },
          { path: 'documents-invite/*', element: <DocumentsInviteRoutes /> },
          { path: 'marketing/*', element: <MarketingRoutes /> },
          { path: 'agents/*', element: <AgentsRoutes /> },
          { path: 'access-control/*', element: <AccessControlRoutes /> },
          { path: '*', element: <Navigate to="." /> },
        ],
      },
    ],
  },
];
